import { createSelector } from "reselect";
import { map, head, path } from "ramda";

import {
  nationalitiesSelector,
  countriesSelector,
  watchListsSelector,
} from "../../../selectors";

export const watchListEntriesSelector = path(["watchListEntries", "entries"]);

export const watchListEntrySelector = path([
  "watchListEntries",
  "watchListEntry",
]);

export const watchListEntriesFiltersSelector = path([
  "watchListEntries",
  "filters",
]);

export const watchListEntriesByWatchListSelector = path([
  "watchListEntriesByWatchList",
  "entries",
]);

export const watchListEntriesByWatchListFiltersSelector = path([
  "watchListEntriesByWatchList",
  "filters",
]);

export const watchListEntriesByWatchListPageInfoSelector = path([
  "watchListEntriesByWatchList",
  "pageInfo",
]);

export const updateWatchListEntrySelector = createSelector(
  watchListEntrySelector,
  head,
);

export const nationalitiesOptionsSelector = createSelector(
  nationalitiesSelector,
  map((n) => ({ value: n.id, label: n.name })),
);

export const countriesOptionsSelector = createSelector(
  countriesSelector,
  map((n) => ({
    value: n.id,
    label: n.name + (n.description !== null ? n.description : ""),
  })),
);

export const watchListsOptionsSelector = createSelector(
  watchListsSelector,
  map((n) => ({ value: n.id, label: n.name })),
);

export const selectCreateWatchListEntryEuTerroristLoading = path([
  "createWatchListEntryEuTerrorist",
  "isLoading",
]);

export const selectUpdateWatchListEntryEuTerroristLoading = path([
  "updateWatchListEntryEuTerrorist",
  "isLoading",
]);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/selectors/index.js